import Vue, { Component } from 'vue';
import { Component as ComponentDecorator } from 'vue-property-decorator';
import CVueInstance from './CVueInstance';

@ComponentDecorator({
  props: {
    backgroundImageUrl: String,
    backgroundColor: String,
    mainBetterText: String,
    mainBetterTextColor: String,
    textColor: String,
    backgroundText: String,
    mainText: String,
    subText: String,
    byBetterCorp: Boolean,
  },
})

export default class Parallex1 extends CVueInstance {
  get getId() {
    return `${this.GetMyId()}-parallex1`;
  }
  public mounted() {
    this.tools.fullscreen();
  }
}
